var exports = {
  "kL": "xcc377c0b--aa3327--container",
  "AS": "xcc377c0b--aa3327--item",
  "Pf": "xcc377c0b--aa3327--label",
};

module.exports = exports;
